export const appContext = {
  APP_ENVIRONMENT() {
    try {
      return document.querySelector('meta[name="app-env"]')
        ?.attributes.getNamedItem('content')
        ?.value;
    } catch (e) {
      console.warn('meta element [APP-ENV] undefined');

      return 'development';
    }
  },

  BRAINTREE_TOKEN() {
    try {
      return document.querySelector('meta[name="braintree-token"]')
        ?.attributes.getNamedItem('content')
        ?.value;
    } catch (e) {
      console.error(
        'meta element [braintree-token] undefined'
      );
    }
  },

  GOOGLE_MERCHANT_ID() {
    try {
      return document.querySelector('meta[name="google-merchant-id"]')
        ?.attributes.getNamedItem('content')
        ?.value;
    } catch (e) {
      console.error(
        'meta element [google-merchant-id] undefined'
      );
    }
  },

  GOOGLE_API_KEY() {
    try {
      return document.querySelector('meta[name="google-map-api-key"]')
        ?.attributes.getNamedItem('content')
        ?.value;
    } catch (e) {
      console.error(
        'meta element [google-map-api-key] undefined'
      );
    }
  }
};
